<template>
    <el-dialog ref="form-saveas" class="form-table-h500" :title="title" :visible.sync="visibleSync"
        :destroy-on-close="true" :before-close="handleClose" :close-on-click-modal="false" width="50%">
        <el-form :model="form" :label-position="labelPosition" label-width="80px" :rules="rules" ref="form">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="组名" prop="name" style="text-align: left">
                        <el-input size="medium" v-model="form.name" autocomplete="off"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="状态" prop="status_b" style="text-align: left">
                        <el-switch v-model="form.status_b"></el-switch>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="所属排班" style="text-align: left">
                        <item-input type="multiselect" v-model="form.relScheduleShiftUsers" :options="this.dicSchedule"
                            :showCount="3" :collapseTags="false"></item-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="所属区域" style="text-align: left">
                        <item-input size="medium" type="multiselect" v-model="form.dicWardIds" :options="this[`ward_auth`]"
                            :showCount="3" :collapseTags="false" placeholder="请选择"></item-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="科室" style="text-align: left">
                        <item-input size="medium" type="multiselect" v-model="form.dicSectionIds"
                            :options="this[`section_auth`]" :showCount="3" :collapseTags="false"
                            placeholder="请选择"></item-input>
                    </el-form-item>
                </el-col>
                <el-col :span="14" style="margin-left: 40px;">
                    <el-radio-group v-model="form.selectWorkerRole" style="display: flex;" size="small">
                        <el-radio style="display: flex;width:30px;" :label="0">全部</el-radio>
                        <el-radio style="display: flex;width:30px;" :label="role.value"
                            v-for="(role, index) in sys_enums.Enum_WorkerRole" :key="index">{{role.label}}</el-radio>
                    </el-radio-group>
                </el-col>
                <el-col :span="1">
                    <el-checkbox v-model="form.isCheckedColor"></el-checkbox>
                </el-col>
                <el-col :span="3" style="display: flex;">
                    <span style="width:50px;">颜色</span>
                    <el-color-picker style="margin-top: -10px;" v-model="form.all_back_color"
                        @change="coverColorToAllWorker()" color-format="rgb" :predefine="predefineColors"></el-color-picker>
                </el-col>
                <el-col :span="16">
                    <el-form-item label="组员" style="text-align: left">
                        <div v-for="(user,index) in form.shiftGroupUserarr" :key="index"
                            style="padding-top: 6px;display: flex;justify-content:space-between;align-items:center;">
                            <item-input style="width:70%;" type="remoteselect" :clearable="true"
                                v-model="form.shiftGroupUserarr[index]" :options="workoption"></item-input>
                            <div style="display: flex;align-items:center;">
                                <span style="width:50px;">颜色</span>
                                <el-color-picker style="margin-top: 10px;" v-model="user.back_color" color-format="rgb"
                                    :predefine="predefineColors"></el-color-picker>
                            </div>
                            <span style="color: #f56c6c; font-size: 13px" v-if="index > 0" @click="deleteUser(user)">
                                <i class="el-icon-remove-outline" style="font-size: 13px; color: #f56c6c; width: 10px"></i>
                                移除
                            </span>
                            <span style="color: #2629f0; font-size: 13px" v-else @click="addUser()">
                                <i class="el-icon-circle-plus-outline"
                                    style="font-size: 13px; color: #2629f0; width: 10px"></i>
                                添加
                            </span>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="SaveAs">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `EditShiftUserGroupForm`,
    props: {
        title: { type: String },
        visible: { type: Boolean },
        data: { type: Object }
    },
    data() {
        return {
            dicSchedule: [],
            form: {
                id: 0,
                name: ``,
                status_b: true,
                relScheduleShiftUsers: [],
                dicWardIds: [],
                dicSectionIds: [],
                shiftGroupUsers: [],
                shiftGroupUserarr: [{
                    value: 0,
                    label: ``,
                    display_order: 1,
                    back_color: ``
                }],
                isCheckedColor: false,
                all_back_color: ``,
                selectWorkerRole: 0
            },
            labelPosition: `right`,
            predefineColors: [`#ff4500`, `#ff8c00`, `#ffd700`, `#90ee90`, `#00ced1`, `#1e90ff`, `#c71585`, `rgb(255, 120, 0)`, `hsv(51, 100, 98)`, `hsl(181, 100%, 37%)`],
            rules: {
                name: [
                    { required: true, message: `请输入组名`, trigger: `blur` }
                ]
            }
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
            this.$store.dispatch(`ADD_CURRENTUSER`)
        }
        this.$store.dispatch(`ADD_SECTION_AUTH`)
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
        this.initData()
    },
    computed: {
        ...mapGetters([`sysuser/workers`, `permissions`, `section_auth`, `sys_enums`, `screenHeight`, `ward_auth`, `currentUser`]),
        workers() {
            return this[`sysuser/workers`]
        },
        workoption() {
            let that = this
            let role = that.form.selectWorkerRole
            return q => {
                let works = role != 0 ? that.workers.filter(d => d.enum_worker_role == role) : that.workers
                works = works.map(d => {
                    return {
                        label: d.name,
                        value: d.id,
                        jianpin: d.abbr,
                        card_no: d.card_no,
                        worker_duty: d.worker_duty,
                        code: d.code,
                        enum_worker_role: d.enum_worker_role
                    }
                })
                if (q && q.keyword) {
                    return works.filter(d => {
                        return (d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1)
                    })
                } else {
                    return works
                }
            }
        },
        visibleSync: {
            get: function() {
                // if (this.visible) {
                //     this.loadOne()
                // }
                return this.visible
            },
            set: function(newval) {
                this.$emit(`update:visible`, newval)
            }
        }
    },
    mounted() {},
    methods: {
        loadOne() {
            this.form = Object.assign(this.form, this.data)
        },
        coverColorToAllWorker() {
            let that = this
            if (that.form.isCheckedColor) {
                let color = that.form.all_back_color
                _.forEach(that.form.shiftGroupUserarr, user => {
                    user.back_color = color
                })
            }
        },
        cancel() {
            this.visibleSync = false
            this.$refs[`form`].resetFields()
        },
        handleClose(done) {
            this.$refs[`form`].resetFields()
            done()
        },
        deleteUser(user) {
            this.form.shiftGroupUserarr = this.form.shiftGroupUserarr.filter((e) => e.value != user.value)
        },
        addUser() {
            var count = this.form.shiftGroupUserarr.length + 1
            this.form.shiftGroupUserarr.push({
                value: 0,
                label: ``,
                display_order: count + 1,
                back_color: this.form.all_back_color
            })
        },
        SaveAs() {
            let that = this
            that.$refs.form.validate(valid => {
                if (valid) {
                    let newData = { ...that.form }
                    if (that.form.shiftGroupUserarr && Array.isArray(that.form.shiftGroupUserarr)) {
                        newData.shiftGroupUsers = that.form.shiftGroupUserarr.map(item => item.value)
                        _.forEach(that.form.shiftGroupUserarr, user => {
                            user.worker_id = user.value
                        })
                    }
                    let erruser = _.find(newData.shiftGroupUsers, i => i == 0)
                    if (erruser > -1) {
                        that.$message.error(`请选择组员`)
                        return false
                    }
                    if (newData.shiftGroupUsers && newData.shiftGroupUsers.length > 1) {
                        let isDuplicate = _.uniq(newData.shiftGroupUsers).length !== newData.shiftGroupUsers.length
                        if (isDuplicate) {
                            that.$message.error(`请删除重复数据`)
                            return false
                        }
                    }

                    let isAdd = that.form.id == 0
                    // 修改前效验
                    return that.checkValidate(isAdd, newData)
                }
            })
        },
        checkValidate(isAdd, newData) {
            let that = this
            let userIds = newData.shiftGroupUsers
            return new Promise((resolve, reject) => {
                let req = this.myaxios.post(`/api/AcisSystem/ShiftUserGroup/CheckUserGroup?userGroupId=${isAdd ? -1 : newData.id}`, userIds)
                req.then(msg => {
                // 修改前效验
                    if (msg !== ``) {
                        this.$confirm(`${msg}，是否继续?`, `提示`, {
                            confirmButtonText: `确定`,
                            cancelButtonText: `取消`,
                            type: `warning`,
                            closeOnClickModal: false
                        }).then(() => {
                            return that.addEdit(isAdd, newData).then(data => {
                                this.$emit(`save-success`)
                                that.visibleSync = false
                                resolve(data)
                            })
                        }).catch(e => { })
                    } else {
                        return that.addEdit(isAdd, newData).then(data => {
                            this.$emit(`save-success`)
                            that.visibleSync = false
                            resolve(data)
                        })
                    }
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        addEdit(isadd, newData) {
            return new Promise((resolve, reject) => {
                let req = this.myaxios[isadd ? `post` : `put`](`/api/AcisSystem/ShiftUserGroup/${isadd ? `Post` : `Put`}`, newData)
                req.then(data => {
                    resolve(data)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        initData() {
            return new Promise((resolve, reject) => {
                let req2 = this.myaxios.get(`/api/AcisSystem/DicSchedule/Get`)
                req2.then((data2) => {
                    var dataArray = _.map(data2, d => {
                        return {
                            value: d.id,
                            label: d.name || `--`,
                            disabled: !d.status_b
                        }
                    })
                    this.dicSchedule = dataArray.sort((a, b) => {
                        // 将 disabled 为 false 的元素排在后面
                        if (a.disabled && !b.disabled) {
                            return 1
                        } else if (!a.disabled && b.disabled) {
                            return -1
                        }
                        // 如果 disabled 相等，则按照 value 属性排序，可以根据需要调整排序条件
                        return a.value - b.value
                    })
                }).catch(e => {
                    console.log(e)
                    reject(e)
                })
            })
        }
    },
    watch: {
        data: function() {
            this.loadOne()
        }
    }

}
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/Dictionary/Schedule/EditShiftUserGroupForm.vue